export const AVAILABLE_CTAS_CONTENTS_COUNT = 4;
